/**
 * @file DesignsStatusLine.tsx
 * @description Строка состояния панели «Дизайны» (решения 2026-10-12):
 * «Сейчас в работе: «Осень 2026» / на сайте: «Как было»», одной строкой —
 * если это один и тот же дизайн; «свой вид, не сохранён в дизайн» и «вид
 * без сохранённого дизайна» — когда совпадений нет. Правила — в
 * `lib/site-view/design-status.ts`.
 */

import type { SiteDesignItem } from "../../../lib/api-site-designs";
import { designsStatus } from "../../../lib/site-view/design-status";

export function DesignsStatusLine({ items }: { items: readonly SiteDesignItem[] }) {
  const status = designsStatus(items);
  return (
    <p className="type-caption flex flex-col text-on-surface-variant" data-testid="designs-status" aria-live="polite">
      {status.kind === "same" ? (
        <span>{status.text}</span>
      ) : (
        <>
          <span>{status.draft}</span>
          <span>{status.published}</span>
        </>
      )}
    </p>
  );
}
